<template>
    <tr @click="openEditLine(index)">
        <td class="pl-10">
            <div class="col">
                <strong>
                    <h6>{{ item.name }}</h6>
                </strong>
                {{ item.description }}
            </div>
        </td>
        <td class="text-center">{{ item.sale_general_quantity }}</td>
        <td class="text-center">{{ item.prev_return_qty }}</td>
        <td v-if="item.isEdit">
            <div class="td-inline">
                <input
                  v-model.trim="item.return_qty"
                  type="number" class="form-control"
                  placeholder="Qty" :min="0"
                >
            </div>
        </td>
        <td class="text-center" v-else >{{ item.return_qty }}</td>
        <td class="text-center">{{ item.rate }}</td>
        <td class="text-center">{{ item.vat }}%</td>
        <td class="text-center">{{ vatAmount }}</td>
        <td class="text-center">{{ totalReturnAmount }}</td>
    </tr>

</template>
<script setup>
import {computed, watch, inject } from "vue";

const props = defineProps({
  item: Object,
  index: Number,
  onOpenEditItem: Function,
})

const emit = defineEmits(['onOpenEditItem']);
const showError = inject('showError');

const openEditLine = (i) => {
  emit('onOpenEditItem', i)
}

const returnQty = computed(() => props.item.return_qty ?? 0);

const vatAmount = computed(() => {
  if(props.item.vat === 0) {
    return 0
  }

  return (props.item.vat/100 * (props.item.rate * props.item.return_qty)).toFixed(2);
})

const totalReturnAmount = computed(() => {
  return props.item.return_amount = returnQty.value * props.item.rate + parseFloat(vatAmount.value);
})

watch(returnQty, (newValue, oldValue) => {
  if (newValue && newValue > 0) {
    const quantity = props.item.sale_general_quantity;
    const prevReturnQty = props.item.prev_return_qty ?? 0;
    const remainingQty = (quantity - prevReturnQty);
    if(newValue > remainingQty) {
      showError("Return quantity can not be more than order quantity")
      props.item.return_qty = remainingQty;
      return;
    }
  }
})
</script>
<style scoped>
.btn-dlt{
    color: #ea5455;
}
.tr-edit td{
    min-width: 80px;
}
</style>